import React, { useEffect, useState, useRef } from 'react'
import '../../Styles/NavBar.css'
import TreLogo384 from '../../Assets/TreLogo384.png'
import { Link } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import DonutLargeIcon from '@mui/icons-material/DonutLarge';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
function NavBar() {
  const [value,setValue] = useState(1);
  const [displayMobNavBar,setDisplayMobNavBar] = useState('none');
  const [mobNavToggler,setMobNavToggler] = useState('|||');
  useEffect(()=> {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    }
  },[]);
  const menuRef = useRef(null);
  const handleClickOutside = (e) => {
    if (!menuRef.current.contains(e.target)) {
      setDisplayMobNavBar('none');
      setMobNavToggler('|||');
    }
  }

  function handleMobNavOpen() {
    if (displayMobNavBar === 'flex') {
      setDisplayMobNavBar('none');
      setMobNavToggler('|||');
    } else {
      setDisplayMobNavBar('flex');
      setMobNavToggler('X');
    }
  }
  return (
    <>
    <nav className='NavBar'>
      <Link className='NavBar-logo' to="/"><img className="NavBar-logo-img" alt="Trehan Logo" src={TreLogo384}/></Link>
        <div className='NavBar-bar'>
            <Link className='Nav-tab m-l-0' to="/">Home</Link>
            <Link className='Nav-tab' to="/"> </Link>
            <Link className='Nav-tab' to="/"> </Link>
            <Link className='Nav-tab' to="/"> </Link>
            <Link className='Nav-tab' to="/"> </Link>
            <Link className='Nav-tab' to="/wargaming">Wargaming</Link>
            <Link className='Nav-tab' to="/toolbox">Toolbox</Link>
            <Link className='Nav-tab' to="/businesses">Business Search</Link>
            <Link className='Nav-tab' to="/about">About</Link>
        </div>
    </nav>
    <nav className='NavBar-mobile' ref={menuRef}>
      <Link className='NavBar-mobile-logo' to="/"><img className="NavBar-mobile-logo-img" alt="Trehan Logo" src={TreLogo384}/></Link>
      <div className='NavBar-mobile-tabs'>
        <button className='NavBar-mobile-button' onClick={handleMobNavOpen}>{mobNavToggler}</button>
          <ui className='Nav-mobile-subtabs' style={{display:displayMobNavBar}}>
            <li className='Nav-mobile-subtab' muted="muted" onMouseEnter={() => setValue(value+1)}><Link className='Nav-subtab-link'to="/"><HomeIcon style={{fontSize:'1.1rem',marginRight:'10px'}}/><p>Home</p></Link></li>
            <li className='Nav-mobile-subtab' muted="muted" onMouseEnter={() => setValue(value+1)}><Link className='Nav-subtab-link' to="/wargaming"><MilitaryTechIcon style={{fontSize:'1.1rem',marginRight:'10px'}}/><p>Wargaming</p></Link></li>
            <li className='Nav-mobile-subtab' muted="muted" onMouseEnter={() => setValue(value+1)}><Link className='Nav-subtab-link' to="/businesses"><QueryStatsIcon style={{fontSize:'1.1rem',marginRight:'10px'}}/><p>Business Search</p></Link></li>
            <li className='Nav-mobile-subtab' muted="muted" onMouseEnter={() => setValue(value+1)}><Link className='Nav-subtab-link' to="/toolbox"><HomeRepairServiceIcon style={{fontSize:'1.1rem',marginRight:'10px'}}/><p>Toolbox</p></Link></li>
            <li className='Nav-mobile-subtab' muted="muted" onMouseEnter={() => setValue(value+1)} style={{borderRadius:'0 0 10px 10px'}}><Link className='Nav-subtab-link' to="/about"><DonutLargeIcon style={{fontSize:'1.1rem',marginRight:'10px'}}/><p>About</p></Link></li>
          </ui>
      </div>
      
    </nav>
    </>
  )
}

export default NavBar

/**
 * 
 *  <li className='Nav-mobile-subtab' muted="muted" onMouseEnter={() => setValue(value+1)} style={{borderRadius:'0 0 10px 10px'}}><Link className='Nav-subtab-link' to="/contactus"><ConnectWithoutContactIcon style={{fontSize:'1.1rem',marginRight:'10px'}}/><p>Contact</p></Link></li>
 */